import { render, staticRenderFns } from "./LECO_PasswordReset.vue?vue&type=template&id=3fa0cc5a&scoped=true"
import script from "./LECO_PasswordReset.vue?vue&type=script&lang=js"
export * from "./LECO_PasswordReset.vue?vue&type=script&lang=js"
import style0 from "./LECO_PasswordReset.vue?vue&type=style&index=0&id=3fa0cc5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa0cc5a",
  null
  
)

export default component.exports